import { Link } from 'react-router-dom';
import { ArrowLeft, ChevronRight } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import { useLang } from '../i18n/LanguageContext';

export default function PageLayout({ crumb, title, subtitle, heroImage, children, onCTA }) {
  const { t } = useLang();
  return (
    <div>
      <Header onCTA={onCTA || (() => document.getElementById('page-cta')?.scrollIntoView({ behavior: 'smooth' }))} />

      {/* Hero */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden">
        {heroImage && (
          <div className="absolute inset-0">
            <img src={heroImage} alt="" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-br from-brand-navy/95 via-brand-navy/90 to-brand-navy/80" />
            <div className="absolute inset-0 bg-black/25" />
          </div>
        )}
        {!heroImage && <div className="absolute inset-0 bg-brand-navy" />}

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm text-white/70 mb-6">
            <Link to="/" className="hover:text-brand-yellow flex items-center gap-1"><ArrowLeft className="w-3 h-3" /> {t('common.backHome')}</Link>
            <ChevronRight className="w-3 h-3 text-white/40" />
            <span className="text-brand-yellow">{crumb}</span>
          </nav>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-4xl">
            {title}
          </h1>
          {subtitle && <p className="text-white/80 text-lg mt-6 max-w-3xl leading-relaxed">{subtitle}</p>}
        </div>
      </section>

      {children}

      <Footer />
    </div>
  );
}

export function PageCTA({ title, body }) {
  const { t } = useLang();
  return (
    <section id="page-cta" className="py-16 bg-brand-yellow">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h3 className="text-2xl md:text-3xl font-bold text-brand-navy">{title}</h3>
        <p className="text-brand-navy/80 mt-3 max-w-2xl mx-auto">{body}</p>
        <Link to="/#contact" className="inline-flex items-center gap-2 mt-6 px-8 py-3 bg-brand-navy text-white font-semibold rounded hover:bg-[#070d33] transition">
          {t('common.contactUs')}
        </Link>
      </div>
    </section>
  );
}
